import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

export const getCreditCardsForClient = serviceBase({
  request: ({ clientId }) => {
    return axiosClient.get(`/cards/client/${clientId}`);
  }
});

export const deleteCreditCard = serviceBase({
  request: ({ cardId }) => {
    return axiosClient.delete(`/cards/${cardId}`);
  }
});

export const addCardToClient = serviceBase({
  request: data => {
    // Use temporalToken (one-time token) for this public form endpoint
    // instead of the session token, as the backend expects a one-time token
    return axiosClient.post('/cards', data, {
      useTemporalToken: true
    });
  }
});
